import Phaser, {
    Display
} from 'phaser'

import QuizAnswer from './QuizAnswer';

let xmlLoader;
let parent;
let thisLocation;
let questionsArray;
let thisQuestion;
let score;
let answersArray = [];
let thisPanel;
let guide;
const quizLength = 10;

export default class QuizQuestions extends Phaser.Scene {
    constructor() {
        super('wharenuiQuizQuestions')
    }
    preload() {

    }
    init(data) {
        xmlLoader = this.scene.get('xmlLoader');
        thisLocation = data.thisLocation;
        parent = this.scene.get(thisLocation + 'QuizMessaging');
        parent.events.on('shutdown', this.stopped, this);
        questionsArray = [];
        thisQuestion = 0;
        score = 0;
        guide = this.scene.get('guide');
    }

    //Pick 10 questions
    create() {

        //Set the xml to the questions section
        xmlLoader.setSection('questions');

        //Store all possible question #s
        let allNumbersArray = Phaser.Utils.Array.NumberArray(0, xmlLoader.getSpeechLength() - 1);
        //Put them in a random order
        Phaser.Utils.Array.Shuffle(allNumbersArray);

        //Pick the first 10
        for (let index = 0; index < quizLength; index++) {
            questionsArray.push(allNumbersArray[index]);
        }
        this.updateQuestion();

    }

    //Called for each new question
    updateQuestion() {
        xmlLoader.setSection('questions');
        //Kill graphics and answers from last question
        Phaser.Utils.Array.Each(answersArray, (obj) => {
            obj.destroyIt();
        }, this)
        answersArray = [];


        //Check if that was the last question
        if (thisQuestion == questionsArray.length) {
            parent.finishedQuiz(score, quizLength);
            return;
        }

        //Update the xml for the question
        xmlLoader.setSpeechNum(questionsArray[thisQuestion]);
        //Find which panel the answer is in
        thisPanel = xmlLoader.getTagFromSpeech('hotspot')[0].innerHTML.trim();
        parent.highlightPanel(thisPanel);
        //Get the text for the question and start answers
        this.getText();
    }


    getText() {
        //Look for language each time
        let lang = xmlLoader.getLanguageTag();
        this.qText = xmlLoader.getTag('q', lang);
        this.qText = this.qText[0].innerHTML.trim()

        answersArray = [];
        //Hold the button objects from answer class to pass to guide
        let btnArray = [];
        //Get the <a> tag from the already selected language tag
        let answers = xmlLoader.getTag('a', lang);
        //temporarily hold the new answer object
        let a;
        //for each answer found in the xml
        for (let index = 0; index < answers.length; index++) {
            //create a new answer object
            a = new QuizAnswer({
                scene: this,
                text: answers[index].innerHTML.trim(),
                correct: xmlLoader.getAttribute('correct', answers[index]),
                holder: guide
            });
            //Hold the objects in an array
            answersArray.push(a);
            //hold the buttons created in the objects in an array
            btnArray.push(a.getButton());
        }

        //shuffle order of answers
        Phaser.Utils.Array.Shuffle(btnArray);

        //Setup the guide's speech bubble to handle the quiz content
        guide.speechBubble({
            width: 394,
            text: this.qText,
            objs: btnArray,
            isButtons: true,
            align: 'left'
        });
    }

    //To be called when answer is clicked
    answerGiven(val) {
        //deactive answers
        Phaser.Utils.Array.Each(answersArray, (obj) => {
            let btn = obj.getButton();
            btn.disableInteractive();
        }, this)
        //increase question number
        thisQuestion++;
        if (val == 'true') {
            //Wait before showing next question
            this.incScore();
            this.time.delayedCall(1500, this.updateQuestion, this, this);
            return;
        }
        //wait before showing wrong messaging
        this.time.delayedCall(1500, parent.wrongAnswer, [this.qText], parent);



    }
    //called from the answer object if the answer is correct
    incScore() {
        score++;
    }

    //listens for parent to be shutdown and shutdowns too
    stopped() {
        parent.events.off('shutdown');
        this.scene.stop(thisLocation + 'QuizQuestions');
    }

}